import { useForm } from 'react-hook-form';
import {
  BookAgendaSlotAdminFormValues,
  bookAgendaSlotAdminFormResolver,
} from './schema';

export type BookAgendaSlotAdminUseForm = ReturnType<
  typeof useForm<BookAgendaSlotAdminFormValues>
>;

export const useBookAgendaSlotAdminForm = (
  defaultValues?: Partial<BookAgendaSlotAdminFormValues>,
) => {
  const bookAgendaSlotAdminForm = useForm<BookAgendaSlotAdminFormValues>({
    resolver: bookAgendaSlotAdminFormResolver,
    defaultValues: {
      mode: 'select',
      ...defaultValues,
    },
    // mode: 'all',
  });

  return { bookAgendaSlotAdminForm };
};
